"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var VisibiltyHidden32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M11.901 21.319c-1.751-.771-3.481-2.236-6.076-4.82 4.397-4.377 6.312-5.56 10.05-5.56 1.995 0 3.473.344 5.083 1.323l1.511-1.51C20.392 9.462 18.481 9 15.875 9 11.031 9 8.6 10.566 3.016 16.163a.473.473 0 000 .674c3.105 3.112 5.236 4.976 7.349 6.02l1.536-1.538z" }),
    react_1.default.createElement("path", { d: "M15.875 12.232c-2.434 0-4.406 1.911-4.406 4.267 0 1.417.72 2.661 1.815 3.437l1.443-1.443c-.724-.393-1.219-1.133-1.219-1.994 0-1.265 1.06-2.292 2.366-2.292.861 0 1.608.45 2.022 1.116l1.438-1.438a4.434 4.434 0 00-3.459-1.653z" }),
    react_1.default.createElement("path", { d: "M8.123 23.639L24.013 7.75a.987.987 0 011.4 0l.129.131a.99.99 0 010 1.4L9.653 25.168a.99.99 0 01-1.401 0l-.129-.129a.99.99 0 010-1.4zM28.743 15.924a76.017 76.017 0 00-3.556-3.371c-.604-.533-1.139-.551-1.67-.02s-.476 1.008.021 1.453a63.346 63.346 0 012.395 2.273c-4.396 4.378-6.312 5.562-10.05 5.562-.231 0 .107-.018-.672-.016-1.029.002-1.18.211-1.742.773s-.49.932.138 1.035c.375.045 1.458.146 2.276.146 4.845 0 7.278-1.568 12.859-7.164a.469.469 0 00.001-.671z" }))); };
var StyledVisibiltyHidden32 = styled_components_1.default(VisibiltyHidden32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledVisibiltyHidden32;
var templateObject_1;
//# sourceMappingURL=VisibiltyHidden32.js.map